export function showCelebration(message: string) {
  const root = document.createElement('div');
  root.className = 'toast toast--celebration';
  root.innerHTML = `
    <span class="toast__icon" aria-hidden="true">🎉</span>
    <span>${message}</span>
  `;
  document.body.appendChild(root);
  requestAnimationFrame(() => root.classList.add('is-show'));
  setTimeout(() => {
    root.classList.remove('is-show');
    setTimeout(() => root.remove(), 300);
  }, 3000);
}

export function showToast(message: string) {
  const root = document.createElement('div');
  root.className = 'toast';
  root.innerHTML = `<span>${message}</span>`;
  document.body.appendChild(root);
  requestAnimationFrame(() => root.classList.add('is-show'));
  setTimeout(() => {
    root.classList.remove('is-show');
    setTimeout(() => root.remove(), 300);
  }, 1500);
}
